import { useState } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      text: 'Collaborare con PM Resources è stata la scelta migliore per la nostra azienda. Hanno compreso perfettamente le nostre esigenze e fornito candidati eccellenti in tempi record.',
      name: 'Laura Ferretti',
      role: 'CEO, Innovate Solutions',
      avatar: 'LF',
      rating: 4.9,
    },
    {
      text: 'Il team di PM Resources ha dimostrato una professionalità eccezionale. La loro capacità di trovare i profili giusti per le nostre posizioni critiche è stata determinante per la nostra crescita.',
      name: 'Giuseppe Romano',
      role: 'Direttore Operativo, Digital Factory',
      avatar: 'GR',
      rating: 5.0,
    },
    {
      text: 'Servizio impeccabile e attenzione ai dettagli. PM Resources non si limita a fornire candidati, ma costruisce partnership strategiche che portano valore reale al business.',
      name: 'Alessandra Conti',
      role: 'HR Manager, Global Tech',
      avatar: 'AC',
      rating: 4.8,
    },
  ];

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const current = testimonials[currentIndex];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Georgia, serif' }}>
            Cosa Dicono i Nostri Clienti
          </h2>
          <p className="text-gray-500">( Testimonianze )</p>
        </div>

        <div className="relative">
          <div className="flex items-start gap-8 mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-gray-900 text-white rounded-full text-sm font-semibold whitespace-nowrap">
              <i className="ri-star-fill text-orange-400"></i>
              {current.rating}/5.0
            </div>
          </div>

          <div className="mb-10">
            <div className="text-6xl text-gray-300 mb-4">"</div>
            <p className="text-2xl text-gray-800 leading-relaxed max-w-3xl" style={{ fontFamily: 'Georgia, serif' }}>
              {current.text}
            </p>
          </div>

          <div className="flex items-center gap-4">
            <div className="w-16 h-16 rounded-full flex items-center justify-center text-white text-xl font-bold" style={{background:'#1E3A5F'}}>
              {current.avatar}
            </div>
            <div>
              <div className="text-lg font-semibold text-gray-900">{current.name}</div>
              <div className="text-base text-gray-600">{current.role}</div>
            </div>
          </div>

          <div className="absolute bottom-0 right-0 flex gap-3">
            <button 
              onClick={handlePrev}
              className="w-13 h-13 bg-white border border-gray-300 rounded-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line text-gray-900 text-xl"></i>
            </button>
            <button 
              onClick={handleNext}
              className="w-13 h-13 rounded-lg flex items-center justify-center hover:opacity-90 transition-colors cursor-pointer"
              style={{background:'#1E3A5F'}}
            >
              <i className="ri-arrow-right-line text-white text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}